import React, { Component } from 'react';
import { Route, Routes } from "react-router-dom";
import { withNotie } from 'react-notie';
import CookieConsent from 'react-cookie-consent';
import ReactPixel from 'react-facebook-pixel';

import IconCookie from './IconCookie';
import Header from '../containers/Header';
import SecondHandBoardgamesListPage from '../containers/SecondHandBoardgamesListPage';
import SecondHandBoardgamePage from '../containers/SecondHandBoardgamePage';
import BoardgamePage from '../containers/BoardgamePage';
import BoardgamesListPage from '../containers/BoardgamesListPage';
import AdminBoardgamesListNightPage from '../containers/AdminBoardgamesListNightPage';
import AdminBoardgamesListPage from '../containers/AdminBoardgamesListPage';
import AdminBoardgamePage from '../containers/AdminBoardgamePage';
import AdminCategoriesListPage from '../containers/AdminCategoriesListPage';
import AdminCategoryPage from '../containers/AdminCategoryPage';
import AdminSecondHandBoardgamesListPage from '../containers/AdminSecondHandBoardgamesListPage';
import AdminSecondHandBoardgamePage from '../containers/AdminSecondHandBoardgamePage';
import LoginPage from '../containers/LoginPage';
import Boot from './Boot';
import Loading from './Loading';
import Footer from './Footer';
import { facebookPixel } from '../config';
import AdminEventsListPage from '../containers/AdminEventsListPage';
import '../sass/App.sass';

class App extends Component {
  componentDidMount() {
    this.props.checkSession();
    this.setViewportHeightVariable();
    window.addEventListener('resize', this.setViewportHeightVariable);

    console.log('£££££££', facebookPixel.id);
    ReactPixel.init(facebookPixel.id);
    ReactPixel.revokeConsent();
  }

  componentDidUpdate() {
    if (this.props.shouldShowNotie) {
      this.props.notie[this.props.notieType](this.props.notieMessage);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setViewportHeightVariable);
  }

  setViewportHeightVariable() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  render() {
    if (this.props.isBootingSession) {
      return <Boot />;
    }

    return (
      <React.Fragment>
        <Header />
        <Routes>
          <Route path="/" exact element={<BoardgamesListPage />} />
          <Route path="/replay" exact element={<SecondHandBoardgamesListPage />} />
          <Route path="/replay/:id" exact element={<SecondHandBoardgamePage />} />
          <Route path="/boardgames/:id" exact element={<BoardgamePage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/night" exact element={<AdminBoardgamesListNightPage />} />
          <Route path="/admin/boardgames" exact element={<AdminBoardgamesListPage />} />
          <Route path="/admin/boardgames/create" element={<AdminBoardgamePage />} />
          <Route path="/admin/boardgames/:id" element={<AdminBoardgamePage />} />
          <Route path="/admin/categories" exact element={<AdminCategoriesListPage />} />
          <Route path="/admin/categories/create" element={<AdminCategoryPage />} />
          <Route path="/admin/categories/:id" element={<AdminCategoryPage />} />
          <Route path="/admin/replay" exact element={<AdminSecondHandBoardgamesListPage />} />
          <Route path="/admin/replay/create" element={<AdminSecondHandBoardgamePage />} />
          <Route path="/admin/replay/:id" element={<AdminSecondHandBoardgamePage />} />
          <Route path="/admin/events" exact element={<AdminEventsListPage />} />
        </Routes>
        <Footer />
        { this.props.loading && <Loading /> }
        <CookieConsent
          location="bottom"
          buttonText="Accetto"
          onAccept={ReactPixel.grantConsent}>
          <h1 className="font-serif text-white font-black text-xl mb-8 md:mb-4">Sì, anche noi utilizziamo i cookie!</h1>
          <div className="flex flex-col md:flex-row items-center">
            <IconCookie className="mb-8 md:mb-0 md:mr-4 w-24 h-24" />
            <p>
              Utilizziamo i cookie per migliorare la tua esperienza all'interno della nostra Libreria. Puoi dare un'occhiata alla nostra <a href="https://smart-gaming.it/privacy-policy/" target="_blank" rel="noopener noreferrer" className="font-bold hover:underline">Privacy Policy</a> cliccando <a href="https://smart-gaming.it/privacy-policy/" target="_blank" rel="noopener noreferrer" className="font-bold hover:underline">qui</a>.<br />
              Dichiari di accettare l'utilizzo dei nostri cookie chiudendo o nascondendo questo banner oppure proseguendo con la navigazione di questa pagina.
            </p>
          </div>
        </CookieConsent>
      </React.Fragment>
    );
  }
}

export default withNotie(App);